import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

import { EventBus, Topics, Types } from '@/event-bus'

import environment from '../environment'
import store from '../store'
import http from './http'

const firebaseConfig = {
  apiKey: environment.FIREBASE_CONFIG.API_KEY,
  authDomain: environment.FIREBASE_CONFIG.AUTH_DOMAIN,
  databaseURL: environment.FIREBASE_CONFIG.DATABASE_URL,
  projectId: environment.FIREBASE_CONFIG.PROJECT_ID,
  storageBucket: environment.FIREBASE_CONFIG.STORAGE_BUCKET,
  messagingSenderId: environment.FIREBASE_CONFIG.MESSAGING_SENDER_ID,
  appId: environment.FIREBASE_CONFIG.APP_ID,
  measurementId: environment.FIREBASE_CONFIG.MEASUREMENT_ID,
}
const firebaseApp = initializeApp(firebaseConfig)
getAnalytics(firebaseApp)

// Retrieve an instance of Firebase Messaging so that it can handle background
// messages.
export const messaging = getMessaging(firebaseApp)

const handleMessage = (cb) => {
  onMessage(messaging, (payload) => {
    cb(payload)
  })
}

export const initHandleMessage = () => {
  handleMessage((data) => {
    EventBus.$emit(Topics.NOTIFICATIONS, {
      message: data.notification.body,
      title: data.notification.title,
      type: Types.INFO,
    })

    const audio = new Audio('/notification-sound.mp3')
    audio.play()
  })
}

export const handleVapidToken = (times = 2) => {
  if (times <= 0) {
    return
  }
  getToken(messaging, { vapidKey: environment.VAPID_KEY })
    .then(async (currentToken) => {
      if (currentToken) {
        await http.post('accounts/notification', { token: currentToken }, false)
      } else {
        // Show permission request UI
        console.error(
          'No registration token available. Request permission to generate one.'
        )
      }
    })
    .catch((err) => {
      if (Notification.permission !== 'granted') {
        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            handleVapidToken(times--)
          } else {
            EventBus.$emit(Topics.NOTIFICATIONS, {
              message: 'Não será possível receber alertas',
              type: Types.WARNING,
            })
          }
        })
        return
      }

      console.error(err)
    })
}

export const serviceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((reg) => {
        console.log(`Service Worker Registration (Scope: ${reg.scope})`, reg)
      })
      .catch((error) => {
        const msg = `Service Worker Error (${error})`
        console.error(msg)
      })
  } else {
    console.warn('Service Worker not available')
  }
}

export const initFirebase = () => {
  if (store.state.auth.isAuthenticated) {
    initHandleMessage()

    handleVapidToken()
  }
}
